module.exports = __webpack_public_path__ + "img/Flag_of_the_United_Arab_Emirates.78a052e8.svg";